import {
  PlaneBufferGeometry,
  MeshBasicMaterial,
  Mesh,
  Matrix4,
  DoubleSide,
  Color
  // RepeatWrapping
} from "three";

const cache = {};

class Prop {
  
  constructor( asset, size = 32 ) {

    if( !cache[size] ) cache[size] = {} // so we can cache similar size geos
    if( !cache[asset.name] ) cache[asset.name] = {} // so we can cache similar bitmap materials

    /* SETUP */
    const useBitmap = ( window.CONFIG && window.CONFIG.materials ) ? window.CONFIG.materials.bitmap :  false;
    const useWireframe = ( window.CONFIG && window.CONFIG.materials ) ? window.CONFIG.materials.wireframe :  false;
    
    /* GEO */
    let geometry;

    if( !cache[size].geometry ){
      geometry = new PlaneBufferGeometry( size, size );
      geometry.applyMatrix4( new Matrix4().makeTranslation(0,size/2,0) )
      cache[size].geometry = geometry;
      
    }else{
      geometry =  cache[size].geometry;
    }

    /* MATERIAL */
    let material;
    if( !cache[asset.name].material && window.ASSETS && useBitmap ){
      // material = window.ASSETS.textures.find(obj => { return obj.name === name }).material
      material = asset.material
      material.needsUpdate = false;
      cache[asset.name].material = material
    }else if( !cache[asset.name].material ){
      material = new MeshBasicMaterial();
      material.needsUpdate = false;
      cache[asset.name].material = material
    }else{
      material = cache[asset.name].material;
    }
    
    if( useBitmap ) material.side = DoubleSide;
    if( useWireframe ) material.wireframe = useWireframe;

     /* COLORS */
    if( !cache.colors ){

      cache.colors = {}
      cache.colors.on = new Color(0xffffff9e);
      cache.colors.on.convertSRGBToLinear();
      cache.colors.off = new Color(0xFFFFFF);
      cache.colors.off.convertSRGBToLinear();
      material.color.set( cache.colors.off );
    }

    

    /* MESH */
    const mesh = new Mesh( geometry, material );
    mesh.matrixAutoUpdate = true;
    // if ( useBitmap && Math.random() < 0.5 ) mesh.scale.x = -1;

    
    /* FUNCTIONS */

    mesh.onOver = ()=>{
      // const c = new Color(0xff0ff020); // green
      // const c = new Color('rgba(255,255,255,.75)') // green
      // mesh.material.color.set( c );
      // mesh.translateY( size/4 );
      material.color.set( cache.colors.on );
    }

    mesh.onOut = ()=>{
      // const c = new Color(0xffffff); // white
      // mesh.material.color.set( c );
      // mesh.translateY( -size/4 );
      material.color.set( cache.colors.off );
    }

    // mesh.onClick = ()=>{
    //   console.log( 'CLICKED', asset.name );
    // }

    return mesh;
  }

}

export { Prop };